import Vue from "vue"
import Vuex from "vuex"
import mutations from "./mutations"
import actions from "./actions"
import _ from "underscore"
import utils from "../utils";

Vue.use(Vuex)

const state = {
  initmenus: [
    {
      key: utils.uuid(),
      icon: "mdi-map",
      name: "运力监控大屏",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-truck",
          name: "运力监控大屏",
          active: false,
          path: "/map",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-dashboard",
          name: "每日数据统计",
          active: false,
          path: "/daily",
          roles: [],
        },
      ]
    },
    {
      key: utils.uuid(),
      icon: "mdi-sale",
      name: "销售管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-history",
          name: "历史数据管理",
          active: false,
          path: "/statistics/history",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-transfer",
          name: "发班数据管理",
          active: false,
          path: "/statistics/transport",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-post",
          name: "线路列表",
          active: false,
          path: "/postline/list",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-plus",
          name: "添加线路",
          active: false,
          path: "/postline/create",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-launch",
          name: "项目计划",
          active: false,
          path: '/projectmanage/projects',
          roles: [],
        },
      ]
    },
    {
      key: utils.uuid(),
      icon: "mdi-home-city-outline",
      name: "市场管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-receipt",
          name: "投资收益测算",
          active: false,
          path: "/projectmanage/costcal",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-counter",
          name: "线路收益表",
          active: false,
          path: "/projectmanage/linerevenue",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-counter",
          name: "线路收益表(3)",
          active: false,
          path: "/projectmanage/linerevenue3",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-counter",
          name: "线路收益表(4)",
          active: false,
          path: "/projectmanage/linerevenue4",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-counter",
          name: "线路收益表(KM)",
          active: false,
          path: "/projectmanage/linerevenuekm",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-sine-wave",
          name: "线路时间表",
          active: false,
          path: "/projectmanage/timecal",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-calendar-check",
          name: "日运行时间表",
          active: false,
          path: "/orders/calc",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-calendar-check",
          name: "周运行时间表",
          active: false,
          path: "/orders/calcweek",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-calendar-check",
          name: "周运行时间表(历史)",
          active: false,
          path: "/orders/calchisweek",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-calendar-check",
          name: "历史运行时间表",
          active: false,
          path: "/orders/calchis",
          roles: [],
        },
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-view-dashboard",
      name: "运营管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-truck-check",
          name: "任务派车管理",
          active: false,
          path: "/dispatchplan2",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-truck-check",
          name: "调车运营审批",
          active: false,
          path: "/dispatchapproval",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-calendar-check",
          name: "调度计划生成",
          active: false,
          path: "/dispatch/list",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-order-bool-descending-variant",
          name: "路单管理",
          active: false,
          path: "/orders/list",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-exclamation",
          name: "路单异常",
          active: false,
          path: "/orders/exception",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-bee",
          name: "蜂羽订单",
          active: false,
          path: "/orders/fengyu",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-office-building",
          name: "邮局管理",
          active: false,
          path: "/postoffice/list",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-fuel",
          name: "油价联动",
          active: false,
          path: "/postoffice/oilprice",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-vector-line",
          name: "车辆比例系数",
          active: false,
          path: "/postoffice/carratio",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-finance",
          name: "调车价格统计",
          active: false,
          path: '/finance/selfbillchart',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-tune-variant",
          name: "结算账单管理",
          active: false,
          path: '/settle/summary',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-tune",
          name: "结算账单明细",
          active: false,
          path: '/settle/items',
          roles: [],
        },
      ]
    },
    {
      key: utils.uuid(),
      icon: "mdi-truck-outline",
      name: "运力池管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-truck-check",
          name: "车辆使用情况",
          active: false,
          path: "/runningtable",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-car-key",
          name: "车辆管理",
          active: false,
          path: "/vehicle/vehicle",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account-multiple",
          name: "司机管理",
          active: false,
          path: "/carrier/driver",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account-multiple",
          name: "承运商管理",
          active: false,
          path: "/carrier/list",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-crosshairs-gps",
          name: "GPS设备管理",
          active: false,
          path: "/vehicle/gps",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-fuel",
          name: "车辆能耗管理",
          active: false,
          path: "/vehicle/energyconsumption",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-car-key",
          name: "车辆运行轨迹",
          active: false,
          path: "/vehicle/car",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-ev-station",
          name: "充电桩管理",
          active: false,
          path: "/vehicle/chargingpile",
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "充电数据管理",
          active: false,
          path: "/vehicle/recharge",
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "ETC数据管理",
          active: false,
          path: "/vehicle/etc",
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "油卡数据管理",
          active: false,
          path: "/vehicle/fuelcard",
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "车型管理",
          active: false,
          path: "/vehicle/list",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "车辆黑名单",
          active: false,
          path: "/vehicle/block",
          roles: [],
        },
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-car-cog",
      name: "车务中心",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "服务商管理",
          active: false,
          path: "/vehiclecenter/serviceprovider",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "车辆维修管理",
          active: false,
          path: "/vehiclecenter/repair",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "车辆保养记录",
          active: false,
          path: "/vehiclecenter/maintenance",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "油卡管理",
          active: false,
          path: "/vehiclecenter/oilcard",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "电卡管理",
          active: false,
          path: "/vehiclecenter/electriccard",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "ETC管理",
          active: false,
          path: "/vehiclecenter/etccard",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "保险管理",
          active: false,
          path: "/vehiclecenter/insurance",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "车辆折旧管理",
          active: false,
          path: "/vehiclecenter/depreciation",
          roles: [],
        },
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-home-city-outline",
      name: "综合管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "工作日志",
          active: false,
          path: "/projectmanage/dailyrecord",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "合同列表",
          active: false,
          path: '/contract/list',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-plus",
          name: "添加合同",
          active: false,
          path: "/contract/add",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-message-text-outline",
          name: "消息管理",
          active: false,
          path: "/manage/message",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-alert-circle-outline",
          name: "考核异常管理",
          active: false,
          path: "/manage/exception",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account-check",
          name: "司机绩效管理",
          active: false,
          path: "/manage/driverperformance",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account-clock-outline",
          name: "司机请假管理",
          active: false,
          path: "/manage/driverleave",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "合作车队",
          active: false,
          path: "/carrier/partner",
          roles: [],
        },
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-finance",
      name: "财务管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "项目财务报表",
          active: false,
          path: "/projectmanage/report",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "财务账单明细",
          active: false,
          path: '/finance/financialbill',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "自营账单管理",
          active: false,
          path: '/finance/selfbill',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "应付(自营)管理",
          active: false,
          path: "/finance/selfpayable",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-truck-check",
          name: "车辆里程统计",
          active: false,
          path: "/statisticsvehiclegps",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "车辆成本管理",
          active: false,
          path: '/finance/carcost',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "投标线路标的",
          active: false,
          path: "/projectmanage/marketdata",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "资金利息成本",
          active: false,
          path: '/finance/zijincostinterest',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "上游账单管理",
          active: false,
          path: '/finance/upbill',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "下游账单管理",
          active: false,
          path: '/finance/downbill',
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "应收管理",
          active: false,
          path: "/finance/receivable",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "应收(泌阳)管理",
          active: false,
          path: "/finance/byreceivable",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "应付管理",
          active: false,
          path: "/finance/payable",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "营收日报",
          active: false,
          path: "/finance/managedaily",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "项目统计数据",
          active: false,
          path: "/finance/report",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "进项票管理",
          active: false,
          path: "/finance/incomebill",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-view-list",
          name: "销项票管理",
          active: false,
          path: "/finance/outputbill",
          roles: [],
        }
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-map-legend",
      name: "地图数据管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-map-marker",
          name: "点位管理",
          active: false,
          path: "/map/location",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-map-marker-path",
          name: "线路管理",
          active: false,
          path: "/map/line",
          roles: [],
        },
      ]
    },
    {
      key: utils.uuid(),
      icon: "mdi-cog",
      name: "系统管理",
      active: false,
      roles: [],
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-account-group",
          name: "账号管理",
          active: false,
          path: "/system/account",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account-key",
          name: "角色管理",
          active: false,
          path: "/system/role",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account-key-outline",
          name: "权限管理",
          active: false,
          path: "/system/permission",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-math-log",
          name: "系统日志",
          active: false,
          path: "/system/log",
          roles: [],
        },
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-account-cog",
      name: "个人中心",
      active: false,
      roles: [],
      need_permission: false,
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-account",
          name: "账号设置",
          active: false,
          roles: [],
          path: "/user/setting",
          need_permission: false,
        },
      ],
    },
    {
      key: utils.uuid(),
      icon: "mdi-script",
      name: "DEV",
      active: false,
      roles: [],
      username: "root",
      children: [
        {
          key: utils.uuid(),
          icon: "mdi-script",
          name: "路单抓取任务",
          active: false,
          path: "/cptmcp/task",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account",
          name: "车管平台账号",
          active: false,
          path: "/cptmcp/account",
          roles: [],
        },
        {
          key: utils.uuid(),
          icon: "mdi-account",
          name: "高德地图开发",
          active: false,
          path: "/dev/amap",
          roles: [],
          username: "root",
        },
        {
          key: utils.uuid(),
          icon: "mdi-truck",
          name: "默认派车任务",
          active: false,
          path: "/dev/dispatchplantemplate",
          roles: [],
          username: "root",
        },
        {
          key: utils.uuid(),
          icon: "mdi-truck",
          name: "车辆监控",
          active: false,
          path: "/dev/vehiclemonit",
          roles: [],
          username: "root",
        },
        {
          key: utils.uuid(),
          icon: "mdi-refresh",
          name: "刷新应收应付",
          active: false,
          path: "/dev/refreshreceivepay",
          roles: [],
          username: "root",
        },
        {
          key: utils.uuid(),
          icon: "mdi-cog",
          name: "系统设置",
          active: false,
          path: "/dev/setting",
          roles: [],
          username: "root",
        },
      ]
    },
  ],
  rolecolors: {
    "root": "#F00",
    "admin": "#F08",
    "gm": "#F0F",
    "pm": "#F80",
    "caiwu": "#F88",
    "caiwu2": "#F88",
    "kuaiji": "#F8F",
    "chuna": "#8F8",
    // "pm2": "#08F",
    "jiesuan": "#800",
    "henan": "#808",
    "guangdong": "#80F",
    "jiangxi": "#880",
    "zhejiang": "#88F",
    "guangxi": "#8F0",
  },
  rolenames: {
    root: "超级管理员",
    admin: "管理员",
    gm: "总经理",
    pm: "项目经理",
    // pm2: "项目经理",
    caiwu: "财务负责人",
    caiwu2: "财务",
    kuaiji: "会计",
    chuna: "出纳",
    jiesuan: "结算",
    henan: "河南驻点",
    guangdong: "广东驻点",
    jiangxi: "江西驻点",
    zhejiang: "浙江驻点",
    guangxi: "广西驻点",
  },
  allroles: [
    { text: "超级管理员", value: "root" },
    { text: "管理员", value: "admin" },
    { text: "总经理", value: "gm" },
    { text: "项目经理", value: "pm" },
    // { text: "项目经理", value: "pm2" },
    { text: "财务负责人", value: "caiwu" },
    { text: "财务", value: "caiwu2" },
    { text: "会计", value: "kuaiji" },
    { text: "出纳", value: "chuna" },
    { text: "结算", value: "jiesuan" },
    { text: "河南驻点", value: "henan" },
    { text: "广东驻点", value: "guangdong" },
    { text: "江西驻点", value: "jiangxi" },
    { text: "浙江驻点", value: "zhejiang" },
    { text: "广西驻点", value: "guangxi" },
  ],
  avatar: "",
  userid: "",
  username: "",
  name: "",
  role: "",
  permissions: [],
  navTitle: "",
  navLogo: "",
  navTabs: [],
  navTabIndex: -1,
  uploadtask_title: "",
  uploadtask_model: false,
  uploadtask_type: "",
}
function checkRoles(roles, role) {
  return !_.isArray(roles) || roles.length === 0 || roles.indexOf(role) > -1;
}
function checkPermission(menu, spermissions) {
  let permissions = spermissions || [];
  if (menu.path) return permissions.includes(menu.path);
  if (menu.children?.length) return menu.children.some(n => permissions.includes(n.path));
}
function checkMenuPermission(menu, { username, permissions }) {
  // console.log('checkMenuPermission', menu, { username, permissions });
  if (menu.username) {
    return menu.username === username;
  }
  return (username === "root" || menu.need_permission === false || checkPermission(menu, permissions))
}
function _getMenus(menus, path, { username, permissions, debug }) {
  // if (debug){
  //   console.log('_getMenus', menus, path, username, permissions);
  // }
  let result1 = [];
  for (let i = 0; i < menus.length; i++) {
    let menu1 = menus[i];
    if (checkMenuPermission(menu1, { username, permissions })) {
      if (menu1.children?.length > 0) {
        let result2 = [];
        for (let j = 0; j < menu1.children.length; j++) {
          let menu2 = menu1.children[j];
          if (checkMenuPermission(menu2, { username, permissions })) {
            menu2.active = menu2.path === path;
            result2.push({ ...menu2 });
          }
          // console.log('result2', result2);
        }
        menu1.active = !!_.findWhere(result2, { path });
        if (result2.length > 0) result1.push({ ...menu1, children: [...result2] });
      }
      else {
        menu1.active = menu1.path === path;
        result1.push({ ...menu1 });
      }
    }
  }
  // console.log('menus', menus, path, username, permissions, result1);
  return result1;
}
function checkUrlPermission(url1, url2) {
  let url1_list = url1.split('/').filter(n => !!n);
  let url2_list = url2.split('/').filter(n => !!n);
  return url1_list[0] === url2_list[0];
}
function _checkMenu(menus, path, { username, permissions }) {
  // console.log('_checkMenu', menus, path, username, permissions);
  let default_url = null;
  let level1_url = null;
  for (let i = 0; i < menus.length; i++) {
    let menu1 = menus[i];
    if (checkMenuPermission(menu1, { username, permissions })) {
      if (menu1.children?.length > 0) {
        let level2_url = null;
        for (let j = 0; j < menu1.children.length; j++) {
          let menu2 = menu1.children[j];
          if (checkMenuPermission(menu2, { username, permissions })) {
            if (menu2.path === path) {
              // console.log({ path });
              return true;
            }
            if (!level2_url && permissions.includes(menu2.path)) level2_url = menu2.path;
            if (level2_url && checkUrlPermission(menu2.path, path)) {
              level2_url = menu2.path;
            }
            else {
              level2_url = null;
            }
            if (!default_url && level2_url) default_url = level2_url;
          }
        }
        if (!default_url && level2_url) default_url = level2_url;
      }
      else if (menu1.path === path) {
        // console.log({ path });
        return true;
      }
      if (!level1_url && permissions.includes(menu1.path)) level1_url = menu1.path;
      if (level1_url && checkUrlPermission(menu1.path, path)) {
        level1_url = menu1.path;
      }
      else {
        level1_url = null;
      }
    }
  }
  if (!default_url && level1_url) default_url = level1_url;
  if (!default_url && permissions[0]) default_url = permissions[0];
  if (default_url) {
    // console.log({ default_url });
    return default_url;
  }
  return false;
}
const getters = {
  rolename: (state) => () => {
    return state.rolenames[state.role];
  },
  getmenus: (state) => (path) => {
    // let menus = [];
    // for (let i = 0; i < state.initmenus.length; i++) {
    //   let menu = { ...state.initmenus[i] };
    //   if (checkRoles(menu.roles, state.role) === false) continue;
    //   if (menu.username && menu.username !== state.username) continue;
    //   if (menu.children) {
    //     menu.active = !!_.findWhere(menu.children, { path });
    //     let children = [];
    //     for (let j = 0; j < menu.children.length; j++) {
    //       let cmenu = menu.children[j];
    //       if (checkRoles(cmenu.roles, state.role) === false) continue;
    //       if (cmenu.username && cmenu.username !== state.username) continue;
    //       cmenu.active = cmenu.path === path;
    //       children.push({ ...cmenu });
    //     }
    //     menu.children = children;
    //     if (menu.children.length > 0) menus.push({ ...menu })
    //   }
    //   else {
    //     menu.active = menu.path === path;
    //     menus.push({ ...menu });
    //   }
    // }
    // return menus;
    return _getMenus(state.initmenus, path, { username: state.username, permissions: state.permissions });
  },
  checkmenu: (state) => (path, username, permissions) => {
    let menus = _getMenus(state.initmenus, path, { username, permissions, debug: true });
    return _checkMenu(menus, path, { username, permissions });
  },
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
